export const iconFontAwesomeMapsSuitcase = (
	<i className="fa-solid fa-suitcase"></i>
);
